<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.searchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getDistributionStationUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">转运站账户列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateDistributionStationUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.searchCardShow = !mainTable.searchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getDistributionStationUserTableRecords" />
                </Col>
            </Row>
        </Card>

        <DistributionStationUserEdit ref="distributionUserModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat } from '@/libs/baseModelFormat';
import { dateRender } from '@/libs/tableRowTimeRender';
import DistributionStationUserEdit from './distributionStation-user-edit';
import { getDistributionStationUserList } from '@/api/modules/account-management/distributionStation-user-management';

export default {
    name: 'DistributionStationUserList',
    components: {
        SearchCard,
        StandPaginationTable,
        DistributionStationUserEdit
    },
    props: {
        departmentList: {
            type: Array,
            default: () => []
        },
        companyList: {
            type: Array,
            default: () => []
        }
    }, 
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '姓名', key: 'userDistributionStationName', align: 'center' },
                    { title: '登录账号', key: 'userName', align: 'center' },
                    { title: '关联转运站', key: 'distributionStationName', align: 'center' },
                    { title: '手机号码', key: 'userDistributionStationPhone', align: 'center' },
                    {
                        title: '审核',
                        key: 'userDistributionStationApproval',
                        align: 'center',
                        render: (h, params) => h('span', approvalFormat(params.row.userDistributionStationApproval))
                    },
                    { 
                        title: '创建时间', 
                        key: 'userDistributionStationCreateAt', 
                        align: 'center', 
                        render: (h, params) => dateRender(h, params.row.userDistributionStationCreateAt) 
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => h('Button', {
                            props: {
                                type: 'text',
                                size: 'small',
                                shape: 'circle'
                            },
                            on: {
                                click: () => this.onUpdateDistributionStationUser(params.row)
                            }
                        }, '编辑')
                    }
                ],
                data: [],
                searchCardShow: false,
                searchForm: [
                    { label: '登录账号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userDistributionStationName', sql: 'like' },
                    { label: '关联转运站', type: 'Input', value: '', name: 'distributionStationName', sql: 'like' },
                    { label: '审核状态', type: 'Select', name: 'userDistributionStationApproval', sql: 'in', options: [{ value: 1, key: '通过' }, { value: 0, key: '未通过' }] }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getDistributionStationUserTableRecords();
    },
    methods: {
        getDistributionStationUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            getDistributionStationUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                else {
                    this.$Message.error(res.message || '获取转运站用户列表失败');
                }
            }).catch(error => {
                console.error('获取转运站用户列表失败:', error);
                this.$Message.error('获取转运站用户列表失败');
            }).finally(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateDistributionStationUser() {
            this.$refs.distributionUserModal.showModal('');
        },
        onUpdateDistributionStationUser(distributionStationUserRow) {
            this.$refs.distributionUserModal.showModal(distributionStationUserRow.userDistributionStationLoginUuid);
        }
    }
};
</script>

<style scoped>
</style>
